import type { ReactNode } from 'react';
import { useStore } from 'zustand';

import { toast, type ToastItem, toastStore } from './toast.store';
import { TOAST_TEXT } from './toast.text';
import { ToastItemView } from './toast-item.ui';

export interface ToastHostProps {
  /** 토스트 한 건을 그리는 방법. 없으면 기본 모양 */
  renderItem?: (item: ToastItem, dismiss: (id: string) => void) => ReactNode;
}

/** app 레이어가 한 번만 마운트한다. */
export function ToastHost({ renderItem }: ToastHostProps) {
  const items = useStore(toastStore, (state) => state.items);

  return (
    <div
      aria-label={TOAST_TEXT.region}
      aria-live="polite"
      className="pointer-events-none fixed right-0 bottom-0 z-(--z-toast) flex max-w-full flex-col items-end gap-2 p-4"
    >
      {items.map((item) =>
        renderItem ? (
          <div key={item.id} className="pointer-events-auto">
            {renderItem(item, toast.dismiss)}
          </div>
        ) : (
          <ToastItemView key={item.id} item={item} onDismiss={toast.dismiss} />
        ),
      )}
    </div>
  );
}
